/**
 * Pair It With bundle-add modal.
 *
 * Clicking the "+" button opens a modal with two independent panels —
 * the current PDP's own product and the paired product — each with its
 * own size/option picker (see pair-it-with-picker.liquid). The main
 * panel defaults to whichever variant is already selected live on the
 * page; the paired panel defaults to its own first-available variant.
 * Either can be changed inside the modal. "Add both to cart" stays
 * disabled until both panels resolve to a real, in-stock variant, then
 * adds both together in one request and opens the cart drawer.
 */
(function () {
  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function currentVariantId(productFormId) {
    if (!productFormId) return null;
    var form = document.getElementById(productFormId);
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function panelVariants(panel) {
    var script = panel.querySelector('[data-pair-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function optionFieldsets(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('[data-pair-option]'));
  }

  function selectedValues(panel) {
    var fieldsets = optionFieldsets(panel);
    var values = [];
    for (var i = 0; i < fieldsets.length; i++) {
      var checked = fieldsets[i].querySelector('input:checked');
      if (!checked) return null; // this option group has nothing picked yet
      values.push(checked.value);
    }
    return values;
  }

  function resolveVariant(panel) {
    var fieldsets = optionFieldsets(panel);
    if (fieldsets.length === 0) {
      // No option pickers rendered at all — the product only has a
      // single variant, so it's always "resolved".
      var id = panel.getAttribute('data-single-variant-id');
      return id ? { id: id, available: true } : null;
    }
    var values = selectedValues(panel);
    if (!values) return null;
    var variants = panelVariants(panel);
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var opts = variant.options || [];
      if (opts.length !== values.length) continue;
      var isMatch = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== values[j]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) return { id: variant.id, available: variant.available };
    }
    return null;
  }

  function setPanelStatus(panel, message) {
    var statusEl = panel.querySelector('[data-pair-panel-status]');
    if (!statusEl) return;
    if (message) {
      statusEl.hidden = false;
      statusEl.textContent = message;
    } else {
      statusEl.hidden = true;
      statusEl.textContent = '';
    }
  }

  function setStatus(body, message) {
    var modalContent = body.closest('.pair-it-with-modal__content');
    var statusEl = modalContent && modalContent.querySelector('[data-pair-status]');
    if (!statusEl) return;
    if (message) {
      statusEl.hidden = false;
      statusEl.textContent = message;
    } else {
      statusEl.hidden = true;
      statusEl.textContent = '';
    }
  }

  function updateSubmitState(body) {
    var submit = body.parentElement.querySelector('[data-pair-submit]');
    var panels = Array.prototype.slice.call(body.querySelectorAll('[data-pair-panel]'));
    var allResolved = true;

    panels.forEach(function (panel) {
      var resolved = resolveVariant(panel);
      panel._resolvedVariant = resolved;
      if (resolved && !resolved.available) {
        setPanelStatus(panel, 'This size is sold out.');
      } else {
        setPanelStatus(panel, null);
      }
      if (!resolved || !resolved.available) allResolved = false;
    });

    if (submit) submit.disabled = !allResolved;
  }

  function syncMainPanelToCurrentSelection(body) {
    var mainPanel = body.querySelector('[data-pair-panel][data-panel-role="main"]');
    if (!mainPanel) return;
    var currentId = currentVariantId(body.getAttribute('data-product-form-id'));
    if (!currentId) return;
    var variants = panelVariants(mainPanel);
    var current = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(currentId)) {
        current = variants[i];
        break;
      }
    }
    if (!current || !current.options) return;
    var fieldsets = optionFieldsets(mainPanel);
    fieldsets.forEach(function (fieldset, i) {
      var value = current.options[i];
      if (value == null) return;
      var input = fieldset.querySelector('input[value="' + CSS.escape(value) + '"]');
      if (input) input.checked = true;
    });
  }

  // Mirrors a size picked in the modal's "main" panel (this PDP's own
  // product) back onto the real, live variant picker on the page
  // itself — so picking a different size in here also updates the
  // actual product page underneath (price, image, URL, etc. all follow
  // from the native change event, same as if the shopper had clicked
  // the real picker directly).
  function syncRealPageSelection(panel, productFormId) {
    if (!productFormId) return;
    var fieldsets = optionFieldsets(panel);
    fieldsets.forEach(function (fieldset) {
      var optionName = fieldset.getAttribute('data-option-name');
      var optionPosition = fieldset.getAttribute('data-option-position');
      var checked = fieldset.querySelector('input:checked');
      if (!checked || !optionName) return;

      var expectedName = optionName + '-' + optionPosition;
      var realInputs = document.querySelectorAll(
        'input[type="radio"][form="' + productFormId + '"]'
      );
      for (var i = 0; i < realInputs.length; i++) {
        var realInput = realInputs[i];
        // Defensive: never treat anything inside the pair-it-with modal
        // itself as a "real" page input, even if it somehow shared the
        // same form id — only the actual PDP's own picker should ever
        // be updated here.
        if (realInput.closest('.pair-it-with-modal__content')) continue;
        if (realInput.name === expectedName && realInput.value === checked.value) {
          if (!realInput.checked) {
            realInput.checked = true;
            realInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    });
  }

  function addBothToCart(body) {
    var submit = body.parentElement.querySelector('[data-pair-submit]');
    var panels = Array.prototype.slice.call(body.querySelectorAll('[data-pair-panel]'));
    var items = panels.map(function (panel) {
      return { id: parseInt(panel._resolvedVariant.id, 10), quantity: 1 };
    });

    submit.setAttribute('aria-disabled', 'true');
    submit.classList.add('loading');
    setStatus(body, null);

    var cart = getCart();
    if (cart) cart.setActiveElement(document.activeElement);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (addResponse) {
        if (addResponse.status) {
          throw addResponse;
        }
        var modal = body.closest('modal-dialog');
        if (modal) modal.hide();
        if (!cart) {
          window.location = window.routes.cart_url;
          return null;
        }
        // Re-fetch the drawer markup fresh, now that the add has
        // committed, instead of relying on the sections snapshot
        // bundled into the add response above — see note in the
        // original single-product add flow this was adapted from.
        var sectionIds = cart.getSectionsToRender().map(function (section) {
          return section.id;
        });
        return fetch(window.location.pathname + '?sections=' + sectionIds.join(','))
          .then(function (response) {
            return response.json();
          })
          .then(function (sections) {
            cart.renderContents({ sections: sections });
          });
      })
      .catch(function (error) {
        var message = (error && (error.description || error.message)) || 'Could not add to cart.';
        setStatus(body, message);
      })
      .finally(function () {
        submit.removeAttribute('aria-disabled');
        submit.classList.remove('loading');
        var cartEl = getCart();
        if (cartEl && cartEl.classList.contains('is-empty')) {
          cartEl.classList.remove('is-empty');
        }
      });
  }

  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest('.pair-it-with__add-opener');
    if (opener) {
      var modalId = opener.getAttribute('data-modal');
      var modal = modalId && document.querySelector(modalId);
      var body = modal && modal.querySelector('[data-pair-modal-body]');
      if (body) {
        syncMainPanelToCurrentSelection(body);
        updateSubmitState(body);
      }
      return;
    }

    var submit = evt.target.closest('[data-pair-submit]');
    if (submit && !submit.disabled) {
      var submitBody = submit
        .closest('.pair-it-with-modal__content')
        .querySelector('[data-pair-modal-body]');
      if (submitBody) addBothToCart(submitBody);
    }
  });

  document.addEventListener('change', function (evt) {
    var fieldset = evt.target.closest('.pair-it-with-modal__option');
    if (!fieldset) return;
    var body = fieldset.closest('[data-pair-modal-body]');
    if (!body) return;

    var panel = fieldset.closest('[data-pair-panel]');
    if (panel && panel.getAttribute('data-panel-role') === 'main') {
      syncRealPageSelection(panel, body.getAttribute('data-product-form-id'));
    }

    updateSubmitState(body);
  });
})();